/** @file quatConjugate: the inverse of a unit quaternion. */
import type { Quat } from '@zilo/pose3d-math/quat/quat';

/** `[-x, -y, -z, w]`: the opposite turn of a unit quaternion. */
export function quatConjugate(q: Quat): Quat {
  return [-q[0], -q[1], -q[2], q[3]];
}
